export default ({ type }) => type === "pod";
